

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class BusinessPaymentFee_ManagedObject

class BusinessPaymentFee_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: cardBrandType
    set cardBrandType(value:number) {
        this.setValueForKey(value, 'cardBrandType');
    }
    get cardBrandType():number {
        return this.valueForKey('cardBrandType');
    }
    set cardBrandTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'cardBrandType');
    }
    get cardBrandTypePrimitiveValue():number {
        return this.primitiveValueForKey('cardBrandType');
    }

    // Property: cardCountry
    set cardCountry(value:string) {
        this.setValueForKey(value, 'cardCountry');
    }
    get cardCountry():string {
        return this.valueForKey('cardCountry');
    }
    set cardCountryPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'cardCountry');
    }
    get cardCountryPrimitiveValue():string {
        return this.primitiveValueForKey('cardCountry');
    }

    // Property: cardType
    set cardType(value:number) {
        this.setValueForKey(value, 'cardType');
    }
    get cardType():number {
        return this.valueForKey('cardType');
    }
    set cardTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'cardType');
    }
    get cardTypePrimitiveValue():number {
        return this.primitiveValueForKey('cardType');
    }

    // Property: channel
    set channel(value:number) {
        this.setValueForKey(value, 'channel');
    }
    get channel():number {
        return this.valueForKey('channel');
    }
    set channelPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'channel');
    }
    get channelPrimitiveValue():number {
        return this.primitiveValueForKey('channel');
    }

    // Property: feeFormat
    set feeFormat(value:string) {
        this.setValueForKey(value, 'feeFormat');
    }
    get feeFormat():string {
        return this.valueForKey('feeFormat');
    }
    set feeFormatPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'feeFormat');
    }
    get feeFormatPrimitiveValue():string {
        return this.primitiveValueForKey('feeFormat');
    }

    // Property: fundingSource
    set fundingSource(value:number) {
        this.setValueForKey(value, 'fundingSource');
    }
    get fundingSource():number {
        return this.valueForKey('fundingSource');
    }
    set fundingSourcePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'fundingSource');
    }
    get fundingSourcePrimitiveValue():number {
        return this.primitiveValueForKey('fundingSource');
    }

    // Property: has3DS
    set has3DS(value:boolean) {
        this.setValueForKey(value, 'has3DS');
    }
    get has3DS():boolean {
        return this.valueForKey('has3DS');
    }
    set has3DSPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'has3DS');
    }
    get has3DSPrimitiveValue():boolean {
        return this.primitiveValueForKey('has3DS');
    }

    // Property: paymentEntityType
    set paymentEntityType(value:number) {
        this.setValueForKey(value, 'paymentEntityType');
    }
    get paymentEntityType():number {
        return this.valueForKey('paymentEntityType');
    }
    set paymentEntityTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'paymentEntityType');
    }
    get paymentEntityTypePrimitiveValue():number {
        return this.primitiveValueForKey('paymentEntityType');
    }

    // Property: threeDSMode
    set threeDSMode(value:number) {
        this.setValueForKey(value, 'threeDSMode');
    }
    get threeDSMode():number {
        return this.valueForKey('threeDSMode');
    }
    set threeDSModePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'threeDSMode');
    }
    get threeDSModePrimitiveValue():number {
        return this.primitiveValueForKey('threeDSMode');
    }

    // Property: transactionFeeFormat
    set transactionFeeFormat(value:string) {
        this.setValueForKey(value, 'transactionFeeFormat');
    }
    get transactionFeeFormat():string {
        return this.valueForKey('transactionFeeFormat');
    }
    set transactionFeeFormatPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'transactionFeeFormat');
    }
    get transactionFeeFormatPrimitiveValue():string {
        return this.primitiveValueForKey('transactionFeeFormat');
    }
    // Relationship: business
    set business(value:BusinessLicense) {
        this.setValueForKey(value, 'business');
    }
    get business():BusinessLicense {
        return this.valueForKey('business') as BusinessLicense;
    }
}
